module.exports = __webpack_public_path__ + "img/farheap.abc1456f.png";